import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DoctorsService } from 'src/app/shared/doctor-service/doctors.service';
import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
import { isEmpty, take } from 'rxjs/operators';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DoctypeService } from 'src/app/shared/doctortype-service/doctype-service/doctype.service';
import { SelectItem } from 'primeng/api/selectitem';
import * as moment from 'moment';
import { UrlModal } from 'src/app/shared/url.model';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-add-clinic',
  templateUrl: './add-clinic.component.html',
  styleUrls: ['./add-clinic.component.css'],
})
export class AddClinicComponent implements OnInit {
  clinicData;
  id: string;
  degrees: SelectItem[];
  clinicDays: SelectItem[];
  cdForm: FormGroup;
  newcdForm: FormGroup;
  isLoading = false;
  userToken: string;
  docData: any;
  texts: string[] = [];
  servicesArray = [];
  profileImage;
  type: string;
  // isHospitalT:boolean=null;
  // isHospitalF:boolean=true;

  constructor(
    private doctorService: DoctorsService,
    private authService: AuthService,
    private doctorTypeService: DoctypeService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.degrees = [
      { label: 'MBBS', value: { name: 'MBBS' } },
      { label: 'BDS', value: { name: 'BDS' } },
      { label: 'MD', value: { name: 'MD' } },
      { label: 'BSC Nursing', value: { name: 'BSC Nursing' } },
      { label: 'B.Pharmacy', value: { name: 'B.Pharmacy' } },
    ];
    this.clinicDays = [
      { label: 'Sunday', value: { name: 'Sunday' } },
      { label: 'Monday', value: { name: 'Monday' } },
      { label: 'Tuesday', value: { name: 'Tuesday' } },
      { label: 'Wednesday', value: { name: 'Wednesday' } },
      { label: 'Thursday', value: { name: 'Thursday' } },
      { label: 'Friday', value: { name: 'Friday' } },
      { label: 'Saturday', value: { name: 'Saturday' } },
    ];
    this.authService.authDataSubject.pipe(take(1)).subscribe((authData) => {
      this.userToken = authData._token;
      this.id = authData._id;
      this.type = authData._type;
    });
    this.oninitClinicForm();
    this.oninitNewClinic();
  }
  oninitNewClinic() {
    this.newcdForm = new FormGroup({
      weekDays: new FormControl(null, Validators.required),
      clinicName: new FormControl(null, Validators.required),
      patientLimit: new FormControl(null, [
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),
        Validators.required,
      ]),
      startTime: new FormControl(null, Validators.required),
      endTime: new FormControl(null, Validators.required),
      line1: new FormControl(null, Validators.required),
      city: new FormControl(null, Validators.required),
      district: new FormControl(null, Validators.required),
      pincode: new FormControl(null, [
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),
        Validators.required,
      ]),
      state: new FormControl(null, Validators.required),
      bookingType: new FormControl(null, Validators.required),
    });
  }
  oninitClinicForm() {
    const patientLimit = this.clinicData ? this.clinicData.patientLimit : null;
    const city = this.clinicData ? this.clinicData.address.city : null;
    const state = this.clinicData ? this.clinicData.address.srate : null;
    const district = this.clinicData ? this.clinicData.address.district : null;
    const pincode = this.clinicData ? this.clinicData.address.pincode : null;
    const line1 = this.clinicData ? this.clinicData.address.line1 : null;
    const clinicName = this.clinicData ? this.clinicData.clinicName : null;
    //const startTime = this.clinicData ? this.clinicData.timming.startTime : null;
    //  const endTime = this.clinicData ? this.clinicData.timming.endTime : null;
    this.cdForm = new FormGroup({
      clinicName: new FormControl(clinicName),
      line1: new FormControl(line1),
      city: new FormControl(city),
      district: new FormControl(district),
      pincode: new FormControl(pincode, [
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),
      ]),
      state: new FormControl(state),
      weekDays: new FormControl(null),

      patientLimit: new FormControl(patientLimit, [
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),
      ]),
      startTime: new FormControl(null),
      endTime: new FormControl(null),
    });
  }
  onSubmitClinicData() {
    this.isLoading = true;
    console.log('Submit Clicked');
    const patientLimit = this.cdForm.value['patientLimit'];
    let workingweekDays = this.cdForm.value['weekDays'];
    let startTime = this.cdForm.value['startTime'];
    let endTime = this.cdForm.value['endTime'];
    const clinicName = this.cdForm.value['clinicName'];
    const district = this.cdForm.value['district'];
    const line1 = this.cdForm.value['line1'];
    const city = this.cdForm.value['city'];
    const pincode = this.cdForm.value['pincode'];
    const state = this.cdForm.value['state'];
    if (workingweekDays && workingweekDays.length > 0) {
      workingweekDays = workingweekDays.map((day) => {
        return day.name;
      });
    }
    this.doctorService
      .setClinicData(
        workingweekDays,
        patientLimit,
        this.clinicData._id,
        startTime,
        endTime,
        clinicName,
        district,
        line1,
        city,
        pincode,
        state,
        this.userToken
      )
      .subscribe(
        (res) => {
          this.isLoading = false;
          this.messageService.add({
            key: 'tc',
            severity: 'success',
            summary: 'success',
            detail: 'you successfully update the clinic data ',
          });
          this.getSingleDoctor();
          // this.sRef.nativeElement.click();
        },
        (error) => {
          this.isLoading = false;
          this.messageService.add({
            key: 'tc',
            severity: 'warning',
            summary: 'failed',
            detail: 'failed to update the clinic ',
          });
        }
      );
  }
  getSingleDoctor() {
    if(this.type == 'DOCTOR'){this.doctorService.getSingleDoctorFromDb(this.id, this.userToken).subscribe(
      (res) => {
        this.docData = res;
        this.docData.experience = this.docData.experience
          ? this.docData.experience
          : 0;
        this.profileImage = 'https://api.doqmatokens.com/' + res.profileImage;
        // this.oninitForm();

        if (res.services.length > 0) {
          this.texts = res.services;
          this.servicesArray = res.services;
        }
      },
      (error) => {
        console.log('error');
        // this.oninitForm();
      }
    );
  }else {
    this.doctorService.getSinglereceptionist(this.id, this.userToken).subscribe(
      (res) => {
        this.docData = res;
        this.docData.experience = this.docData.experience
          ? this.docData.experience
          : 0;
        this.profileImage = 'https://api.doqmatokens.com/' + res.profileImage;
        // this.oninitForm();

        if (res.services.length > 0) {
          this.texts = res.services;
          this.servicesArray = res.services;
        }
      },
      (error) => {
        console.log('error');
        // this.oninitForm();
      }
    );
  }
  }
  onSubmitnewClinicData() {
    this.isLoading = true;
    let workingweekDays = this.newcdForm.value['weekDays'];
    console.log('Submit Clicked in New Data');
    if (workingweekDays && workingweekDays.length > 0) {
      workingweekDays = workingweekDays.map((day) => {
        return day.name;
      });
    }
    const newClinicData = {
      ...this.newcdForm.value,
      weekDays: workingweekDays,
      doctorId: this.id,
    };
    if (this.newcdForm.valid) {
      this.doctorService.AddnewClinic(newClinicData, this.userToken).subscribe(
        (res) => {
          this.isLoading = false;
          this.messageService.add({
            key: 'tc',
            severity: 'success',
            summary: 'success',
            detail: 'you successfully added the clinic ',
          });
          
          this.oninitClinicForm();
    this.oninitNewClinic();
          // this.serRef.nativeElement.click();
        },
        (error) => {
          this.isLoading = false;
          this.messageService.add({
            key: 'tc',
            severity: 'warning',
            summary: 'failed',
            detail: 'failed to add the clinic ',
          });
          // console.log(error);
        }
      );
    } else {
      this.isLoading = false;
      alert('All field are required');
    }
  }
  // isHospitalCheck(b:boolean){
  //   if(b == true){
  //     this.isHospitalT = true;
  //     this.isHospitalF =null;
  //   }else{
  //     this.isHospitalF= true;
  //     this.isHospitalT = null;
  //   }
    
  // }
}
